export type CatalogCategoryFilterValue = "all" | "general" | string;

export const matchesCatalogCategoryFilter = (
  categoryId: number | null | undefined,
  filter: CatalogCategoryFilterValue
): boolean => {
  if (filter === "all") {
    return true;
  }

  if (filter === "general") {
    return categoryId == null;
  }

  return categoryId === Number(filter);
};
